import React from 'react';
import Hero from '../components/Hero';
import Services from '../components/Services';
import SuccessCases from '../components/SuccessCases';
import Pricing from '../components/Pricing';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const Home: React.FC = () => {
  return (
    <>
      <Hero />
      <Services />
      <SuccessCases />
      <Pricing />
      
      {/* Pre-footer CTA */}
      <section className="py-24 relative overflow-hidden">
        <div className="absolute inset-0 bg-mira-accent/5"></div>
        <div className="max-w-4xl mx-auto px-4 text-center relative z-10">
          <h2 className="text-4xl md:text-6xl font-extrabold mb-6 text-white tracking-tight drop-shadow-[0_0_25px_rgba(26,140,255,0.3)]">
            ¿Listo para <span className="text-transparent bg-clip-text bg-gradient-to-r from-mira-accent to-blue-200">automatizar?</span>
          </h2>
          <p className="text-xl text-gray-300 mb-8 font-medium">
            Deja que la IA maneje lo repetitivo mientras tú haces crecer tu negocio.
          </p>
          <Link
            to="/contacto"
            className="inline-flex items-center px-8 py-4 bg-white text-mira-bg font-bold rounded-full hover:bg-gray-100 transition-all transform hover:scale-105 shadow-[0_0_20px_rgba(255,255,255,0.3)]"
          >
            Hablar con un experto <ArrowRight className="w-5 h-5 ml-2" />
          </Link>
        </div>
      </section>
    </>
  );
};

export default Home;